import { render } from "./Section5.vue?vue&type=template&id=fa28d596&scoped=true"
import script from "./Section5.vue?vue&type=script&lang=js"
export * from "./Section5.vue?vue&type=script&lang=js"

import "./Section5.vue?vue&type=style&index=0&id=fa28d596&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa28d596"]])

export default __exports__